import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ListChecksIcon, BrainIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-24 bg-[#F9F9F9] px-4" data-id="element-153">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-154">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-6 max-w-4xl leading-tight" data-id="element-155">
          ¿Te sentís agobiado por la cantidad de tareas y fechas de entrega?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-600 max-w-3xl mb-16" data-id="element-156">
          No saber por dónde empezar, postergar tareas y llegar con estrés a
          cada parcial es más común de lo que pensás.
        </motion.p>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12 w-full" data-id="element-157">
          {/* Item 1 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-158">
            <div className="w-20 h-20 bg-turquoise/10 rounded-full flex items-center justify-center mb-6" data-id="element-159">
              <ClockIcon className="w-10 h-10 text-turquoise" data-id="element-160" />
            </div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-161">
              Falta de tiempo para organizarte
            </h3>
            <p className="text-gray-600" data-id="element-162">
              Sientes que las horas no alcanzan y siempre estás corriendo de
              atrás con las lecturas.
            </p>
          </motion.div>

          {/* Item 2 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-163">
            <div className="w-20 h-20 bg-coralOrange/10 rounded-full flex items-center justify-center mb-6" data-id="element-164">
              <ListChecksIcon className="w-10 h-10 text-coralOrange" data-id="element-165" />
            </div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-166">
              Tareas acumuladas y sin priorizar
            </h3>
            <p className="text-gray-600" data-id="element-167">
              La lista de pendientes crece y no sabés qué es lo más urgente o
              importante para resolver hoy.
            </p>
          </motion.div>

          {/* Item 3 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-168">
            <div className="w-20 h-20 bg-softViolet/10 rounded-full flex items-center justify-center mb-6" data-id="element-169">
              <BrainIcon className="w-10 h-10 text-softViolet" data-id="element-170" />
            </div>
            <h3 className="text-xl font-bold text-[#1A1A1A] mb-4" data-id="element-171">
              Estrés antes de exámenes y parciales
            </h3>
            <p className="text-gray-600" data-id="element-172">
              Llegas a la semana de parciales quemado, durmiendo poco y con la
              cabeza a mil por hora.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}